import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cpassarg(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

return(
    <div>
      
      <Sides/>
       <Helmet>
 
 <title>passing function as argument in c++ tutorial For Beginners</title>
 <meta name="description" content="passing function as argument in c++ tutorial for beginners.passing function as argument in Can argument may be a variable as a constant value that is used in the () of function.CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,passing function as argument in c++ tutorial for beginners,programming language,tutorial for begineers,learn code in free,c++ programming tutorial for beginners,learn code in free online,cpp passing operator,c++ operator,operator in cpp language,C++ passing operator tutorial in english" />
 <link rel="canonical" href="https://www.codeexampler.com/cpp-passing-argument"/>
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Passing function as argument in c++</h1>
    <div className="first">
        <a href="/cpp-user-defined-function">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-history">  <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">Passing function as an argument in C++ An argument may be a variable as a constant value use in the () of function.
</p>



    
<h2 className='headings'>Q-Write a program to check a no is even or odd by using a passing argument?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-10">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-5">using </span>
            <span className="qwerty-2">namespace </span>
            <span className="qwerty-5">std</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">void </span>
            <span className="qwerty-5">check(int i)</span>
            <span className="qwerty-2"> // (int i) is a formal argument</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} {"\n"}
            <span className="qwerty-9"> if </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-2">i</span>
              <span className="qwerty-3"> %</span>
              <span className="qwerty-2"> 2</span>
              <span className="qwerty-3"> ==</span>
              <span className="qwerty-2"> 0</span>
              <span className="qwerty-3">)</span>
              {"\n"}
              <span className="qwerty-3"> &#123; </span>
            {"\n"}
              <span className="qwerty-9"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10"> even no</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-5"> else</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-9"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
              <span className="qwerty-11">odd no</span>
              <span className="qwerty-4"> ";</span>
              {"\n"}
              <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty"> int</span>
              <span className="qwerty-6"> main</span>
              <span className="qwerty-3"> ()</span>
              {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty"> int</span>
              <span className="qwerty-6"> i</span>
              <span className="qwerty-3">;</span>
              {"\n"}
            <span className="qwerty-9"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10"> enter a no</span>
              <span className="qwerty-3"> ";</span>
            {"\n"}
            <span className="qwerty"> cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-2">i</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-9"> check </span>
            <span className="qwerty-3">(i)</span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-5"> // I is a actual argument</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}
              <span className="qwerty-2">enter a no </span>
              <span className="qwerty-11">42 </span>
              {"\n"}
              <span className="qwerty">even no</span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>




<h2 className='headings'>Q-Write a program check greater no by using function?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-10">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-5">using </span>
            <span className="qwerty-2">namespace </span>
            <span className="qwerty-5">std</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">void </span>
            <span className="qwerty-5">maximum</span>
            <span className="qwerty-2"> (int a,int b)</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} {"\n"}
            <span className="qwerty-4"> if </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-2">a</span>
              <span className="qwerty-3"> &#62;</span>
              <span className="qwerty-2"> b</span>
              <span className="qwerty-3">)</span>
              {"\n"}
              <span className="qwerty-9"> cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-2"> a</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5"> else</span>
            {"\n"}
            <span className="qwerty-9"> cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
              <span className="qwerty-2">b</span>
              <span className="qwerty-4">;</span>
              {"\n"}
              <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty"> int</span>
              <span className="qwerty-6"> main</span>
              <span className="qwerty-3"> ()</span>
              {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty"> int</span>
              <span className="qwerty-2"> a</span>
              <span className="qwerty-3">,</span>
              <span className="qwerty-2">b</span>
              <span className="qwerty-3">;</span>
              {"\n"}
            <span className="qwerty-9"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10"> enter 2 no\n</span>
              <span className="qwerty-3"> ";</span>
            {"\n"}
            <span className="qwerty"> cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-2">a </span>
            <span className="qwerty-3">&#62;&#62;</span>
            <span className="qwerty-2"> b</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-9"> maximum </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-2">a</span>
              <span className="qwerty-3">,</span>
              <span className="qwerty-2">b</span>
              <span className="qwerty-3">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"}
              <span className="qwerty">enter a no </span>
              {"\n"}
              <span className="qwerty-2">46</span>
            {"\n"}
              <span className="qwerty-2">58 </span>
              {"\n"}
              <span className="qwerty-5">maximum</span>
              <span className="qwerty-3"> = </span>
              <span className="qwerty-2">58</span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/cpp-user-defined-function"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-history">  <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cpassarg;